<template>
  <div class="flex items-center">
    <IconChevronCircle class="text-text-ternary mr-8 hover:text-red transition duration-200 cursor-pointer"
                       @click.native="$emit('goBackToTickets')"/>
    <div class="flex-1 lg:flex-initial text-md font-bold text-text mr-4 truncate">{{ title }}</div>
    <TicketStatusBadge class="mr-4" :status="status"/>
    <div v-if="status !== 3" class="ml-auto flex items-center
                text-2sm text-text hover:text-red duration-200 cursor-pointer"
         @click="$emit('closeTicket')">
      <IconCrossCircle class="text-red mr-3"/>
      {{ $t('closeLabel') }}
    </div>
  </div>
</template>

<script>
import TicketStatusBadge from "@/components/cabinet/Tickets/TicketStatusBadge";
import IconCrossCircle from "@/components/icons/IconCrossCircle";
import IconChevronCircle from "@/components/icons/IconChevronCircle";
import {mapGetters} from "vuex";

export default {
  name: "TicketsSystemChatHeader",
  components: {IconChevronCircle, IconCrossCircle, TicketStatusBadge},
  props: {
    title: {
      type: String,
    },
    id: {
      type: Number,
      required: true
    },
    status: {
      type: Number,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        closeLabel: 'Close ticket'
      },
      ru: {
        closeLabel: 'Закрыть обращение'
      }
    }
  }
}
</script>